import PropTypes from 'prop-types';
import React from 'react';

import useCampaign from '../../../hooks/use_campaign';
import useTranslation from '../../../hooks/use_translation';
import Trans from '../../translation/trans';
import Countdown from '../count-down';

const Bar = ({ hasCountDown = false }) => {
	const { discount, isActive, timeLeft } = useCampaign();
	const { t } = useTranslation('component_bar');

	if (!isActive) return null;

	const daysLeft = timeLeft ? parseInt(timeLeft.days, 10) : null;
	const showCountdown = hasCountDown && daysLeft !== null && daysLeft < 3;

	return (
		<div className=" py-3 bar-top bg-campaign">
			<div className="container text-center text-start-lg fw-700 d-lg-flex justify-content-center gap-2">
				{showCountdown ? (
					<>
						<div className="mb-1 mb-lg-0">
							<div>
								<Trans i18nKey={'t2'} t={t} />
							</div>
						</div>
						<Countdown timeLeft={timeLeft} />
						<div>
							<Trans
								i18nKey="t1"
								t={t}
								values={{
									discount_amount: discount.amount,
									discount_code: discount.code,
								}}
							/>
						</div>
					</>
				) : (
					<div>
						<Trans
							i18nKey="t3"
							t={t}
							values={{
								discount_amount: discount.amount,
								discount_code: discount.code,
							}}
						/>
					</div>
				)}
			</div>
		</div>
	);
};

Bar.propTypes = {
	hasCountDown: PropTypes.bool,
};

export default Bar;
